import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

/** Aperçu local (localStorage) des polices UI — réservé aux tests (ex. rôle God). */
@Injectable({ providedIn: 'root' })
export class Gt2AppFontPreviewService {
  static readonly STORAGE_KEY = 'gt2_god_font_preview';

  private static readonly IDS: string[] = [
    'roboto',
    'inter',
    'poppins',
    'figtree',
    'lato',
    'merriweather',
    'montserrat',
    'open-sans',
    'space-grotesk',
    'libre-franklin',
    'fira-sans',
    'karla',
    'comfortaa',
  ];

  constructor(@Inject(DOCUMENT) private doc: Document) {}

  getSelectedFontId(): string {
    const v = localStorage.getItem(Gt2AppFontPreviewService.STORAGE_KEY);
    if (v && Gt2AppFontPreviewService.IDS.includes(v)) {
      return v;
    }
    return 'roboto';
  }

  applyFont(fontId: string): void {
    let id = fontId;
    if (!Gt2AppFontPreviewService.IDS.includes(id)) {
      id = 'roboto';
    }
    localStorage.setItem(Gt2AppFontPreviewService.STORAGE_KEY, id);
    this.syncBody();
  }

  /** Applique la classe sur `body` selon le localStorage (et retire les autres). */
  syncBody(): void {
    const body = this.doc.body;
    for (const id of Gt2AppFontPreviewService.IDS) {
      if (id !== 'roboto') {
        body.classList.remove(`gt2-font-${id}`);
      }
    }
    const id = this.getSelectedFontId();
    if (id !== 'roboto') {
      body.classList.add(`gt2-font-${id}`);
    }
  }
}
